import { Row, Col } from 'antd';
import StatCard from '@/components/UI/Cards/StatCard';
import { useInventoryData } from '../hooks/useInventoryData';
import { CheckCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

/**
 * Inventory card component displaying inventory statistics
 * Uses real data from the API
 */
const InventoryCard = () => {
    // Use custom hook for inventory data
    const { 
        inventoryData,
        isLoading, 
        isError,
        error,
        count
    } = useInventoryData();

    // console.log(count, "Count Data in Inventory Cards");

    if (isLoading) {
        return (
            <Row gutter={[16, 16]}>
                {[1, 2, 3].map((index) => (
                    <Col xs={24} sm={12} md={8} key={index}>
                        <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center space-x-4 shadow-sm">
                            <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
                            <div className="flex flex-col flex-1">
                                <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-20"></div>
                                <div className="h-6 bg-gray-200 rounded animate-pulse w-12"></div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        );
    }

    if (isError) {
        return (
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                        <p className="text-red-600">
                            Error loading inventory data: {error?.message || 'Unknown error'}
                        </p>
                    </div>
                </Col>
            </Row>
        );
    }

    // Data configuration for inventory statistics
    const cardData = [
        {
            icon: CheckCircleOutlined,
            title: "In Stock",
            count: count?.in_stock ?? 0,
            iconColor: "text-green-600",
            iconBgColor: "bg-green-100"
        },
        {
            icon: ExclamationCircleOutlined,
            title: "Low on Stock",
            count: count?.low_on_stock ?? 0,
            iconColor: "text-yellow-600",
            iconBgColor: "bg-yellow-100"
        },
        {
            icon: CloseCircleOutlined,
            title: "Out of Stock",
            count: count?.out_of_stock ?? 0,
            iconColor: "text-red-600",
            iconBgColor: "bg-red-100"
        }
    ];

    return (
        <Row gutter={[16, 16]}>
            {cardData.map((stat, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                    <StatCard
                        icon={stat.icon}
                        title={stat.title}
                        count={stat.count}
                        iconColor={stat.iconColor}
                        iconBgColor={stat.iconBgColor}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default InventoryCard;